import React from 'react';
import { Typography, IconButton } from '@mui/material';
import { MainContentPanel } from '../../components/MainContentPanel';
import { Link } from 'react-router-dom';
import { Add } from '@mui/icons-material';
import { DataGridPro, GridColDef } from '@mui/x-data-grid-pro';
import { nbNO } from '@mui/x-data-grid/locales';

export function Folders() {
  return (
    <MainContentPanel>
      <Typography gutterBottom variant="h5">
        <span>Rabatter</span>
        <Link to="/discount/new">
          <IconButton size="large">
            <Add />
          </IconButton>
        </Link>
      </Typography>
      <FolderTable />
    </MainContentPanel>
  );
}

function FolderTable() {
  const rows = [
    { id: 1, name: 'Alle', info: 'Alle rabatter', path: '/discounts/1' },
    { id: 2, name: 'Studenter', info: 'Alle studenter med rabatt', path: '/discounts/2' },
    { id: 3, name: 'Firmaer', info: 'Andre kunder med rabatt', path: '/discounts/3' },
    { id: 4, name: 'Ip-adresse', info: 'Alle med Ip-adresse eller intranett', path: '/discounts/4' },
    { id: 5, name: 'SSO/AD', info: 'Alle med AFDS innlogging', path: '/discounts/5' },
    { id: 6, name: 'Uten kunder', info: 'Rabatter uten tilhørende kunder', path: '/discounts/6' },
  ];

  const columns: GridColDef<(typeof rows)[number]>[] = [
    {
      field: 'name',
      headerName: 'Navn',
      minWidth: 180,
      flex: 1,
      align: 'left',
      headerAlign: 'left',
      renderCell: (params) => <Link to={params.row.path}>{params.row.name}</Link>,
    },
    {
      field: 'info',
      headerName: 'Annen info',
      minWidth: 220,
      flex: 1,
      align: 'left',
      headerAlign: 'left',
    },
  ];

  return (
    <DataGridPro
      autoHeight
      density="compact"
      rows={rows}
      columns={columns}
      localeText={nbNO.components.MuiDataGrid.defaultProps.localeText}
      hideFooter
      disableColumnMenu
      disableColumnFilter
      disableRowSelectionOnClick
      sx={{
        '& .MuiDataGrid-columnHeaderTitle': {
          fontWeight: 700,
        },
      }}
    />
  );
}
